import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";

const useIsTablePos = () => {
  const [deliveryMethod] = usePosOrderDeliveryMethod();
  return deliveryMethod === 3;
};

export default useIsTablePos;
